(function() {
    
    // ---------------------------------------------
    // 【定数定義】
    // ---------------------------------------------
    const SIZE_ID = 'memory'; // ★IDを'memory'に設定★
    const GALLERY_SELECTOR = `#gallery-box-${SIZE_ID}`; 
    const LIGHTBOX_OVERLAY_ID = `custom-lightbox-overlay-${SIZE_ID}`;
    const LIGHTBOX_IMG_ID = `custom-lightbox-img-${SIZE_ID}`;
    const LIGHTBOX_CONTAINER_ID = `custom-lightbox-container-${SIZE_ID}`;
    const CLOSE_BTN_ID = `close-btn-${SIZE_ID}`;
    const NAV_PREV_ID = `nav-prev-${SIZE_ID}`;
    const NAV_NEXT_ID = `nav-next-${SIZE_ID}`;

    const CHATBOT_SELECTOR = 'iframe[title="Tawk.to Chat"]'; 
    
    let allImages = []; 
    let currentImageIndex = 0; 
    
    // ---------------------------------------------
    // 【画像データ】※URL文字列の配列として定義 (ユーザー名なし)
    // ---------------------------------------------
    const imageSources = [
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____rhome_____4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____aaaaabbboo.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____rhome_____2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/______aoyans2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/______aoyans2_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____5roku78__2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____5roku78__7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____5roku78__8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____ayay.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____ayay_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____ayay_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____sii_sapi.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/___06070826____4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____ssui.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/____ssui_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/___06070826___.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/___06070826____2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/___06070826____3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/__ricoworld___9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/___ask_1o.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/__kocco_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/__ricoworld__.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/__ricoworld___2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/__ricoworld___5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/___ymie02_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/___ymie02_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/___ymie02_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/___ymie02_11.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/723rhythm.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/_ch1r0ru_.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/_riri_room_.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/_riri_room_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/10itsu01.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/10itsu01_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/10itsu01_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/10itsu01_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/10itsu01_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/2023momo321_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/2023momo321.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/airio0430_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/aaairixoxo_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/aaairixoxo_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/airio0430.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/bluesky0915_13.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/akihome06.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/akihome06_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/alpha_ltp.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/aoao_bluechan.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/as0815kyo_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/as0815kyo_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/august_babyr5_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/bell__mell_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/bluesky0915.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/bluesky0915_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/bluesky0915_11.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/anzyo.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/anzyo_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ask0320.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/bluewithwhite_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/bluewithwhite_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/bluewithwhite_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/c_u_p_p_y.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/c_u_p_p_y_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/c_u_p_p_y_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/chell__home.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/chell__home_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/chim___ie.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/emilymaione.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/eri_peony.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/eri_peony_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/f___tmk.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/f___tmk_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/f___tmk_12.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/gorata_home_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/brixtonboyboy.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/brixtonboyboy_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ez__12.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ez__12_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ez__12_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ez__12_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ena1210.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ena1210_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/gorata_home.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/gorata_home_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/guu_52haus.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/guu_52haus_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/harunooky.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/harunooky_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/harunooky_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/harunooky_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/harunooky_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/hh_home_5610_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/hamasaki77_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/himy_home.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/himy_home_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/himy_home_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/himy_home_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/himy_home_13.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/homemtirol.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/homemtirol_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/isorabijoux_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/iha_home10.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/iha_home10_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/io_may_833_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/io_may_833_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/io_may_833_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/io_may_833_13.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/iso_kyon.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/iso_kyon_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/iso_kyon_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/iso_kyon_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/iso_kyon_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/iso_kyon_8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/iso_kyon_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/hoshi1986_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/hoshi1986_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/hoshi1986_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/hoshi1986_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/hoshi1986_17.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/hoshi1986_21.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/leesaa_house_17.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kamigram2023.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kamigram2023_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kamigram2023_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kaori_26726.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kaori_26726_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kirakira____31house.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/km_kone.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/km_kone_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kn____log.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kn____log_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/leesaa_house_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/leesaa_house_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/leesaa_house_10.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/leesaa_house_11.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/leesaa_house_14.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/leesaa_house_15.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kanatakuny_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kanatakuny_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kirakira____31hou_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/kirakira____31hou_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/koa_sbr06aus.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/koa_sbr06aus_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/koa_sbr06aus_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/koa_sbr06aus_13.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/lalahome319.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/lalahome319_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mj44i_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/m20220309a.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/m20220309a_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mayuchi_no_ie.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/megu_2boys_mama.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/megu_2boys_mama_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/miiie_noie_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mima_ma0.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mima_ma0_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mima_ma0_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mima_ma0_8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mimiy_322.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mj44i.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/maa0910_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mai___home.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mayu365.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mayu365_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mintnyanya_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mintnyanya_8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mintnyanya_15.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/momoko_121_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/momoko_121_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mshinoie.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/muku_no_kyojin.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/muku_no_kyojin_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/muku_no_kyojin_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/muku_no_kyojin_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/muku_no_kyojin_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/muku_no_kyojin_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/muku_no_kyojin_8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/n___noie_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/n___noie_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mmmhomem_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mu___111.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nacomhome.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nacomhome_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nacomhome_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/mmmhomem.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/niiinnyaaa.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/niiinnyaaa_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nikooooorin_photo.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nody_homelog_18.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nargenhome.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nargenhome_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nargenhome_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nody_homelog_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nody_homelog_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nody_homelog_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nody_homelog_13.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/nody_homelog_15.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/pardo1206_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/o_maruhome19_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/o_maruhome19_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/o_maruhome19_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ogahouse2023.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ogahouse2023_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ogahouse2023_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ordinarybbs_okagu.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ordinarybbs_okagu_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/orobi_ai_home.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/orobi_ai_home_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/orobi_ai_home_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/otogi_chan.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/pardo1206.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/r_mam0922_34.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/peanuts__85.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/peanuts__85_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/r_mam0922.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/r_mam0922_11.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/pooom_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/pooom_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/pooom_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/rokuvivibabys_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/imgrc0095730434.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/imgrc0095730435.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/rikunosuke13.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/rikunosuke13_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/rikunosuke13_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/rinakkynya.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/rinakkynya_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/rinakkynya_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/rinakkynya_10.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ritz_chiiico27.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ritz_chiiico27_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/rokuvivibabys.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/saaaachan1223_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/sachiko_0717.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/sachiko_0717_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/thouse____5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/sys___.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ssmy_home.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ssmy_home_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ssmy_home_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/studio_mou_photo_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/studio_mou_photo_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/studio_mou_photo_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/studio_mou_photo_8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/studio_mou_photo_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/thouse___.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/thouse____2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/thouse____4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/takuto0803.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tacho__home.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tacho__home_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tacho__home_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/taku3_photolife.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/taku3_photolife_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/taku3_photolife_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/taku3_photolife_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/taku3_photolife_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/imgrc0095730652.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tianzihuili.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tianzihuili_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tmtmmama00.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tomokakaishige.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tomokakaishige_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tomokakaishige_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/toro___home.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tsubameswh.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tsubameswh_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tsubameswh_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tsubameswh_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/w1224_house_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/tsumustagram0717_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/uru_sheryl_mon.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/uru_sheryl_mon_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/imgrc0095730726.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/w1224_house.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/w1224_house_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/w1224_house_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/w1224_house_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/w1224_house_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/w1224_house_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/w1224_house_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/uka__ie.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/uka__ie_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/yumam_0201_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/wkn_fam.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/wkn_fam_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/y_i_home.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/yamamol0.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/yucharun_mama.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/yumam_0201.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/wtnbrkrt.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/wtnbrkrt_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/ykr07.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/yuaya17.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/yuaya17_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/yuaya17_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/yukari_na828.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/yukari_na828_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/yukari_na828_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/zu__ch_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/zu__ch.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2024/zu__ch_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_____m03_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_____m03_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_____m03_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_____m03_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____5roku78__6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____5roku78__1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____5roku78__2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____5roku78__3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____5roku78__4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____5roku78__5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____5roku78__8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____yucography__1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____yucography__6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____yucography__13.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____yucography__8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____yucography__10.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/____yucography__12.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__16.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___misahome__10.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___ymie02_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/___ymie02_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__kumasuki___10.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__i_am_gaku___1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__kumasuki___2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__kumasuki___3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__kumasuki___4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__kumasuki___5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__kumasuki___6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__kumasuki___7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__kumasuki___8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__kumasuki___9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__natsungram___1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__natsungram___2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__soem__22.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__soem__1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__soem__3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__soem__6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__soem__7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__soem__8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__soem__9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__soem__15.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__soem__17.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__soem__19.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_runa0311_13.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_ao_baby01_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_ao_baby01_13.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_runa0311_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_runa0311_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_runa0311_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_runa0311_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_runa0311_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_runa0311_8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_runa0311_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_runa0311_10.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/_runa0311_12.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__yk24__1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/__yk24__2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/apollo0204_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/2023tamaru321_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/2023tamaru321_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/akienjoyment_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/akienjoyment_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/am3i___1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/am3i___2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/am3i___3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/apollo0204_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/apollo0204_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/art_____salon_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/art_____salon_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/art_____salon_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/asahi_wfm_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/asahi_wfm_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/asahi_wfm_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/asahi_wfm_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ayane0804_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ayane0804_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ayane0804_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ayane0804_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ayrk_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ayrk_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ayrk_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ayrk_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ayrk_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ayrk_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/chiwamaru_lulu_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/bess_ikeryu_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/bshttskr_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/bshttskr_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/bshttskr_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/bshttskr_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/chaaakya_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/chaaakya_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/chitianxiusan_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/chitianxiusan_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/chitianxiusan_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/chitianxiusan_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/chitianxiusan_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/chiwamaru_lulu_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/emma0912toy_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/emilymaione_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/emma_home28_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/emma_home28_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/emma_home28_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/emma_home28_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/iky__home_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/fukui_yuka__1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/guzurin0618_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/h__mylifegram_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/hagiwara_kikaku_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/haku0820haku_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/haku0820haku_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/haku0820haku_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/hina_16_08_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/hina_16_08_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/hina_16_08_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/hina_16_08_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/home__mii_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/home__mii_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/home__mii_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/home__mii_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/home__mii_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/iky__home_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/iky__home_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/iky__home_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/iky__home_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/homemtirol_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/km_kone_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/isorabijoux_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/j_apan_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/j_apan_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/j_nonmama_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/j_nonmama_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/j_nonmama_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/j_nonmama_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/k_music_yamanashi_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/kaerutotako_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/kahome0315_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/kahome0315_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/kahome0315_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/kamigram2023_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/krn_14_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/krn_14_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/kanakois_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/kanakois_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/kanakois_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/kei_____1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/meko_0824_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mami0822coco_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mami0822coco_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/manmarumama818_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/manmarumama818_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/manna_lifelog_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/manna_lifelog_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mariaka_ie_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mariaka_ie_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mariaka_ie_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mary__camera_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mary__camera_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/meko_0824_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/meko_0824_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/meko_0824_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/meko_0824_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/meko_0824_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mmmhomem_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mementomori_m0501_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mementomori_mako_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mhouse_swh_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mhuru_03_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mi_cal_mina_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mi_cal_mina_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/misa__yh___1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/misaki74_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/millleafearthcamp_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mmmhomem_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mmmhomem_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mmmhomem_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mmmhomem_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mmmhomem_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mykokobabe_11.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/momomo_mama__1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/moon___days10_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mozu_house8_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mozu_house8_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mozu_house8_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/myhome_sc2021_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/myhomemami_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/myhomemami_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/myhomemami_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mykokobabe_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mykokobabe_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mykokobabe_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mykokobabe_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mykokobabe_8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mykokobabe_9.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mochome_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mochome_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mochome_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/mochome_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nalaboo_2021_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nalaboo_2021_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nalaboo_2021_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nasu_home_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nasu_home_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nasu_home_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nasu_home_8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/natsu_maru__1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/natsu_maru__4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nc__home_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nc__home_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/neko_musume_wata_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/neko_musume_wata_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/neko_musume_wata_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/neko_musume_wata_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/neko_musume_wata_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/noonap2024_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nemuuuu14_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/noonap2024_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/noonap2024_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nk___house_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nody_homelog_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nody_homelog_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nody_homelog_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nody_homelog_8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/nody_homelog_10.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/paopao_no_mori_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/oshako0703_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/oshako0703_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ouchi_shanchi_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/owarinaki__tabi_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/owarinaki__tabi_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/paopao_no_mori_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/paopao_no_mori_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/ntm8991_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/oby___ayu_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/oby___ayu_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/oby___ayu_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/oby___ayu_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/oby___ayu_8.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/rin_home2023_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/pehn_insta_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/r__fave_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/r__fave_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/r__fave_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/r__fave_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/r_mam0922_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/r_mam0922_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/rilly__wedding_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/rin_home2023_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/pinhome__1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/pinhome__2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/pinhome__4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/pinhome__6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/rikkun_gram24_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/rikkun_gram24_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/shin5_nozaki_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/rinakkynya_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/rinakkynya_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/sachecon_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/sachecon_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/sh14ori_ffy_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/sh14ori_ffy_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/sh14ori_ffy_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/sh14ori_ffy_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/shin5_nozaki_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/shin5_nozaki_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/sumi__rin_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/sumi__rin_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/srou_ie_11.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/srou_ie_13.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/srou_ie_16.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/srou_ie_17.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tatsukinic_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/sy_tkzw_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/taichi_k1231_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/taichi_k1231_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/taichi_k1231_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/taku3_photolife_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/taku3_photolife_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/takuto0803_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tarosucom0215_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tarosucom0215_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tarosucom0215_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tatsukinic_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tatsukinic_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tatsukinic_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tatsukinic_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/uru0808_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/techi_kapu_0706_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/the_dearest_one_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/the_dearest_one_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tomam0320_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tomam0320_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tomam0320_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tottoko_haooo6_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/uka___y_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/unino__ie_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tsubameswh_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tsubameswh_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/tsubameswh_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yui950114_15.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/walnut_home_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/walnut_home_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/walnut_home_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/walnut_home_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yayoi89_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yui950114_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yui950114_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yui950114_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yui950114_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yui950114_10.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yui950114_11.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yui950114_14.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yukino__1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yukino__2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yukino__4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yukino__6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yumam_0201_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yumam_0201_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yumikokubu_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yumikokubu_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yumikokubu_6.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yumikokubu_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yuriko_310_4.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yuriko_310_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yuriko_310_7.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yuudaikun_3.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yukari_na828_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yukari_na828_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yukari_na828_5.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yumakiie_2.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yumi0518wed_1.jpg",
        "https://image.rakuten.co.jp/gbt-dko/cabinet/alsace-ugc2025/yuudaikun_2.jpg"
    ];
    const TOTAL_IMAGE_COUNT = imageSources.length; 


    // ---------------------------------------------
    // 【ステップ2: ロジック定義】
    // ---------------------------------------------

    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    function assignImagesToGallery(selector) {
        const galleryBox = document.querySelector(selector);
        if (!galleryBox) {
            console.error("Gallery box not found:", selector);
            return;
        }
        
        if (imageSources.length === 0) {
            console.warn("Memory Image sources are empty. No images assigned.");
            return;
        }

        galleryBox.style.visibility = 'hidden';

        allImages = Array.from(galleryBox.querySelectorAll("img"));

        const shuffledSources = shuffleArray(imageSources.slice());

        allImages.forEach((img, index) => {
            img.src = shuffledSources[index % shuffledSources.length]; 
            img.setAttribute('data-index', index); 
            img.setAttribute('data-full', img.src); 
        });

        setTimeout(() => {
            galleryBox.style.visibility = 'visible'; 
        }, 100);
    }

    function updateLightbox(globalIndex) {
        if (globalIndex < 0 || globalIndex >= allImages.length) return;

        currentImageIndex = globalIndex;
        const largeImg = document.getElementById(LIGHTBOX_IMG_ID);
        largeImg.src = allImages[currentImageIndex].src;
        
        const prevBtn = document.getElementById(NAV_PREV_ID);
        const nextBtn = document.getElementById(NAV_NEXT_ID);

        if (prevBtn) {
            prevBtn.style.setProperty('display', currentImageIndex === 0 ? 'none' : 'block', 'important');
        }
        if (nextBtn) {
            nextBtn.style.setProperty('display', currentImageIndex === allImages.length - 1 ? 'none' : 'block', 'important');
        }
    }

    // ---------------------------------------------
    // 【ステップ3: クリックハンドラ関数】
    // ---------------------------------------------
    function handleImageClick(e) {
        e.stopPropagation(); 

        let clickedImage = e.target;
        let index = parseInt(clickedImage.getAttribute('data-index'));

        if (isNaN(index) || index < 0) return; 

        currentImageIndex = index;

        let overlay = document.getElementById(LIGHTBOX_OVERLAY_ID);

        if (!overlay) {
            // --- オーバーレイとボタンの作成ロジック（初回時のみ） ---
            overlay = document.createElement('div');
            overlay.id = LIGHTBOX_OVERLAY_ID;
            overlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.9); z-index: 999999 !important; display: flex; justify-content: center; align-items: center;';

            const imgContainer = document.createElement('div');
            imgContainer.id = LIGHTBOX_CONTAINER_ID; 
            imgContainer.style.cssText = 'position: relative; max-width: 90%; max-height: 90%; display: flex; justify-content: center; align-items: center;';

            const largeImg = document.createElement('img');
            largeImg.id = LIGHTBOX_IMG_ID; 
            largeImg.style.cssText = 'max-width: 100%; max-height: 100%; object-fit: contain;';
            
            const closeLightbox = function() {
                overlay.style.display = 'none';
                document.body.style.overflow = 'auto';
                const chatbot = document.querySelector(CHATBOT_SELECTOR);
                if (chatbot) {
                    chatbot.style.removeProperty('display');
                }
            };

            const closeBtn = document.createElement('div');
            closeBtn.innerHTML = '×';
            closeBtn.id = CLOSE_BTN_ID; 
            closeBtn.style.cssText = 'position: absolute; top: 10px; right: 10px; color: white; font-size: 40px; font-weight: 300; cursor: pointer; padding: 0 15px 5px 15px; border-radius: 50%; background: rgba(0, 0, 0, 0.5); z-index: 1000000 !important; display: block !important;'; 
            closeBtn.onclick = function(e) { e.stopPropagation(); closeLightbox(); }; 

            const prevBtn = document.createElement('div');
            prevBtn.innerHTML = '&#10094;'; 
            prevBtn.id = NAV_PREV_ID; 
            prevBtn.style.cssText = 'position: absolute; left: 0px; color: white; font-size: 60px; cursor: pointer; padding: 10px; z-index: 1000000 !important; top: 50%; transform: translateY(-50%); background: rgba(0, 0, 0, 0.5); border-radius: 0 5px 5px 0;'; 
            prevBtn.onclick = function(e) { e.stopPropagation(); updateLightbox(currentImageIndex - 1); };

            const nextBtn = document.createElement('div');
            nextBtn.innerHTML = '&#10095;'; 
            nextBtn.id = NAV_NEXT_ID; 
            nextBtn.style.cssText = 'position: absolute; right: 0px; color: white; font-size: 60px; cursor: pointer; padding: 10px; z-index: 1000000 !important; top: 50%; transform: translateY(-50%); background: rgba(0, 0, 0, 0.5); border-radius: 5px 0 0 5px;'; 
            nextBtn.onclick = function(e) { e.stopPropagation(); updateLightbox(currentImageIndex + 1); };

            imgContainer.appendChild(largeImg);
            imgContainer.appendChild(closeBtn); 
            imgContainer.appendChild(prevBtn);
            imgContainer.appendChild(nextBtn);

            overlay.appendChild(imgContainer);
            document.body.appendChild(overlay);

            overlay.addEventListener('click', function(e) {
                if (e.target.id === LIGHTBOX_OVERLAY_ID || e.target.id === LIGHTBOX_CONTAINER_ID) {
                    closeLightbox();
                }
            });
        }

        updateLightbox(currentImageIndex);
        overlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        const chatbot = document.querySelector(CHATBOT_SELECTOR);
        if (chatbot) {
            chatbot.style.setProperty('display', 'none', 'important');
        }
    }

    // ---------------------------------------------
    // 【ステップ4: ページ読み込み時の初期化】
    // ---------------------------------------------

    document.addEventListener('DOMContentLoaded', function() {
        
        assignImagesToGallery(GALLERY_SELECTOR);

        const galleryBox = document.querySelector(GALLERY_SELECTOR);
        if (galleryBox) {
            galleryBox.addEventListener('click', function(e) {
                if (e.target.tagName === 'IMG') {
                    
                    const ggScreen = document.getElementById('gg-screen');
                    if (ggScreen) {
                        ggScreen.remove();
                    }
                    
                    handleImageClick(e);
                }
            });
        }
    });

})();